import styled from 'styled-components';
import { MENU_MOBILE_BREAK_POINT } from './constants';

export const Wrapper = styled.div`
	.navbar {
		background: rgba(255, 255, 255, 0.9);
		box-shadow: 0px 0px 15px -8px #0076e3;
		backdrop-filter: blur(8px);
		@media (max-width: 425px) {
			.navbar-brand {
				img {
					height: 20px;
				}
			}
		}

		@media (max-width: ${MENU_MOBILE_BREAK_POINT}px) {
			.navbar-nav {
				flex-direction: column !important;
			}
			.navbar-toggler {
				display: block !important;
			}
		}

		@media (max-width: ${MENU_MOBILE_BREAK_POINT}px) {
			.container {
				display: flex;
				.navbar-brand {
					order: 2;
					display: inline-block;
					padding-top: 0.25rem;
					padding-bottom: 0.25rem;
					margin-right: auto;
					margin-left: auto;
				}
			}
		}

		.with-dropdown {
			position: relative;
		}

		.with-dropdown .nav-link {
			display: flex;
			position: relative;
			background-color: transparent;
			border: none;
			padding-right: 0;
			&:focus {
				outline: none;
			}
			.arrow-up {
				svg {
					transform: rotate(180deg);
				}
			}
		}

		.dropdown-wrapper {
			position: fixed;
			background: rgb(255, 255, 255);
			box-shadow: rgb(126 169 210 / 15%) 0px 0px 50px;
			border-radius: 8px;
			padding: 1.25rem;
			margin-top: 5px;
			margin-left: -110px;
			&.hide {
				display: none;
			}
			&.show {
				display: block;
			}
			ul {
				list-style: none;
				margin: 0;
				padding: 0;
			}
			a {
				font-style: normal;
				font-weight: normal;
				font-size: 16px;
				line-height: 20px;
				color: #4f4f4f;
				text-decoration: none;
				background-color: transparent;
			}
		}
	}
	.overlay {
		display: none;
		position: fixed;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.7);
		z-index: 200;
		opacity: 0;
		transition: all 0.5s ease-in-out;

		top: 0;
		left: 0;
		&.active {
			display: block;
			opacity: 1;
		}
	}
	.navbar-toggleable-md .navbar-collapse {
		width: unset;
	}
	.navbar-collapse {
		flex-basis: unset;
	}
	.navbar-brand {
		font-weight: 500;
	}
	.navbar-brand img {
		height: 30px;
		margin-top: 10px;
		margin-bottom: 10px;
		margin-right: 5px;
	}

	.navbar-toggler {
		border: none;
	}

	.navbar-nav {
		.nav-link {
			font-style: normal;
			font-weight: normal;
			font-size: 16px;
			line-height: 20px;
			color: #4f4f4f;
			padding-right: 4rem;

			svg {
				margin-left: 0.313rem;
			}
			&:hover {
				color: #009ddb;
				svg {
					path {
						fill: #009ddb;
					}
				}
			}
			&:active {
				color: #ff8f1c;
				svg {
					path {
						fill: #ff8f1c;
					}
				}
			}
			&.active {
				font-style: normal;
				font-weight: bold;
				font-size: 16px;
				line-height: 20px;
				color: #066fc2 !important;
			}
		}
	}

	@media (max-width: 1000) {
		.navbar-brand {
			width: 50%;
			img {
				width: 100%;
			}
		}
	}
	@media (max-width: ${MENU_MOBILE_BREAK_POINT}px) {
		.navbar-collapse {
			width: 60vw;
		}
		.navbar-collapse.showSideMenu {
			width: 60vw;
		}
	}

	@media (max-width: ${MENU_MOBILE_BREAK_POINT}px) {
		.navbar-collapse {
			padding-top: 2rem;
			padding-left: 1rem;
			display: block !important;
			background-color: white;
			width: 17rem;
			height: 100vh;
			position: fixed;
			top: 0;
			left: -300px;
			transition: all 0.3s ease-in;

			&.showSideMenu {
				padding-top: 2rem;
				padding-left: 1rem;
				transition: all 0.3s ease-in;
				display: block;
				background-color: white;
				width: 17rem;
				height: 100vh;
				position: fixed;
				top: 0;
				left: 0;
			}
		}

		.navbar-collapse .menuMobile {
			display: flex;
			margin-bottom: 1.2rem;
		}
		.navbar-collapse .menuMobile div {
			font-size: 1.5em;
		}
		.navbar-collapse .menuMobile button {
			background: transparent;
			border: none;
			position: absolute;
			right: 2rem;
			cursor: pointer;
		}
		.navbar-collapse ul li {
			margin-bottom: 0.7rem;
		}
		.navbar-toggleable-md .navbar-nav .nav-link {
			padding-right: 0.7rem;
			padding-left: 0.7rem;
		}
	}
`;

export default Wrapper;
